export default "__VITE_ASSET__834801d4__"